import { cssEasings } from '@wix/wow-utils';
export default cssEasings;
//# sourceMappingURL=easings.js.map